import { Form } from '@vivaldis/antd-ui'
import { ProcessEmployeeDocumentInput } from '@vivaldis/graphql'
import { Step, useStep } from '../../provider/StepProvider'
import { Employee } from '../../types/Employee'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'
import { ActionBar } from './components/ActionBar'

interface Props {
  employee: Employee
  onIDDocumentSubmit: (
    processEmployeeDocumentInput: ProcessEmployeeDocumentInput
  ) => Promise<Employee | undefined>
}

export const UploadIDDocumentStep = ({
  employee,
  onIDDocumentSubmit
}: Props) => {
  const { step } = useStep()

  if (step !== Step.UploadIdDocumentStep) {
    return null
  }

  return (
    <FormProvider employee={employee} onSubmit={onIDDocumentSubmit}>
      <Form autoComplete="off">
        <FormContent />
        <ActionBar />
      </Form>
    </FormProvider>
  )
}
